<template>
  <v-container fluid class="pa-0 text-center">
    <v-row v-if="isLoggedIn">
      <v-col cols="12">
        <h1>You are already logged in</h1>
        <v-btn
          rounded
          large
          depressed
          color="primary"
          class="mt-12"
          to="/overview"
        >
          <span>Overview page</span><v-icon>{{ icons.mdiArrowRight }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12">
        <div v-if="loading">
          <v-progress-circular indeterminate color="primary" />
        </div>

        <div v-else>
          <div v-if="errorMessage">
            <h3 class="my-4">{{ errorMessage }}</h3>
            <v-btn rounded depressed color="primary" class="mx-4" to="/login"
              >Log in</v-btn
            >
            <v-btn
              rounded
              depressed
              outlined
              color="primary"
              class="mx-4"
              to="/signup"
              >Sign Up</v-btn
            >
          </div>

          <div v-else>
            <ReferralAccountPage
              v-if="isReferralLink"
              :verify-user-link-code="verifyUserLinkCode"
            />
            <ActivateAccountPage
              v-else-if="isActivationLink"
              :verify-user-link-code="verifyUserLinkCode"
            />
            <ResetPassword v-else :verify-user-link-code="verifyUserLinkCode" />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { VERIFY_USER_LINK_CODE_QUERY } from '../../../constants/graphql/users';
  import ResetPassword from './ResetPassword.vue';
  import ActivateAccountPage from './ActivateAccountPage.vue';
  import ReferralAccountPage from './ReferralAccountPage.vue';

  export default {
    name: 'UserLinkLandingPage',
    components: {
      ResetPassword,
      ActivateAccountPage,
      ReferralAccountPage,
    },
    data() {
      return {
        loading: true,
        verifyUserLinkCode: {},
        errorMessage: null,
      };
    },
    computed: {
      isActivationLink() {
        return this.verifyUserLinkCode.linkType == 'ACTIVATION';
      },
      isReferralLink() {
        return this.verifyUserLinkCode.linkType == 'REFERRAL';
      },
    },
    methods: {
      setCookies() {
        if (this.isReferralLink) {
          this.$cookies.set('referralCode', this.$route.params.id, '1d');
        }
      },
    },
    apollo: {
      verifyUserLinkCode: {
        query: VERIFY_USER_LINK_CODE_QUERY,
        variables() {
          return {
            code: this.$route.params.id,
          };
        },
        skip() {
          return this.isLoggedIn;
        },
        fetchPolicy: 'network-only',
        result(response) {
          if (response.data) {
            if (!response.data.verifyUserLinkCode) {
              this.errorMessage =
                'Sorry, something went wrong. Please try reloading the page.';
            } else if (!response.data.verifyUserLinkCode.validCode) {
              if (
                response.data.verifyUserLinkCode.used &&
                response.data.verifyUserLinkCode.email
              ) {
                this.$cookies.remove('referralCode');
                this.$router.push({
                  name: 'Login',
                  params: {
                    prepopulatedEmail: response.data.verifyUserLinkCode.email,
                  },
                });
              } else {
                this.errorMessage =
                  'Sorry, this reset password link has expired or is invalid.';
              }
            }
            this.$store.dispatch('setCoBrandingUrl', {
              companyOffersFreeWill:
                response.data.verifyUserLinkCode.companyOffersFreeWill,
              url: response.data.verifyUserLinkCode.companyLogoUrl,
              name: response.data.verifyUserLinkCode.companyName,
              bannerTitle: null,
              bannerDescription: null,
            });
            this.setCookies();
            this.loading = false;
          }
        },
      },
    },
  };
</script>
